var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconRadioBorder = function SvgIconRadioBorder(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2a14 14 0 1 0 0 28 14 14 0 0 0 0-28m0 26a12 12 0 1 1 0-24 12 12 0 0 1 0 24"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconRadioBorder);
export { ForwardRef as ReactComponent };